import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import en from './locales/en.json'
import ro from './locales/ro.json'

import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'settings',
  menu: [
    {
      title: <FormattedMessage id="settings.menu.title" />,
      key: 'settings',
      icon: 'icmn icmn-cog',
      children: [
        {
          title: <FormattedMessage id="settings.menu.account" />,
          // key: 'settings.account',
          key: 'settings.account.edit',
          url: '/settings/account/edit',
          // children: [
          //   {
          //     title: <FormattedMessage id="settings.menu.account_edit" />,
          //     key: 'settings.account.edit',
          //     url: '/settings/account/edit',
          //   },
          //   {
          //     title: <FormattedMessage id="settings.menu.account_create" />,
          //     key: 'settings.account.create',
          //     url: '/settings/account/create',
          //   },
          // ],
        },
        {
          title: <FormattedMessage id="settings.menu.labels" />,
          key: 'settings.labels',
          url: '/settings/labels',
        },
      ],
      roles: ['business'],
    },
  ],
  routes: [
    {
      path: '/settings/labels',
      async lazy() {
        const Comp = await import('./pages/labels')
        return { Component: Comp.default }
      },
      exact: true,
    },
    {
      path: '/settings/labels/:id',
      async lazy() {
        const Comp = await import('./pages/labels/details')
        return { Component: Comp.default }
      },
      exact: true,
      modal: true,
    },
    {
      path: '/settings/account/create',
      async lazy() {
        const Comp = await import('./pages/account/create')
        return { Component: Comp.default }
      },
      exact: true,
    },
    {
      path: '/settings/account/edit',
      async lazy() {
        const Comp = await import('./pages/account/edit')
        return { Component: Comp.default }
      },
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}

export { load as loadLabels } from './redux/labels/list/actions'
